import React from 'react';
import { Link } from 'react-router-dom';
import { SITE_CONFIG } from '../config';
import { services } from '../data/renovationData';

export default function SiteFooter() {
  const business = SITE_CONFIG.BUSINESS;
  return (
    <footer className="site-footer">
      <div className="footer-main page-width">
        <div className="footer-brand">
          <img src={SITE_CONFIG.ASSETS.LOGO} alt="" width="112" height="112" loading="lazy" />
          <p>Thoughtful renovations, local accountability and a showroom right here in Maricopa.</p>
          <p className="license">Arizona {business.LICENSE}</p>
        </div>
        <div>
          <h2>Renovate</h2>
          <ul>{services.map(service => <li key={service.slug}><Link to={`/services/${service.slug}`}>{service.shortTitle}</Link></li>)}</ul>
        </div>
        <div>
          <h2>Explore</h2>
          <ul>
            <li><Link to="/projects">Projects</Link></li><li><Link to="/about-us">Our story</Link></li>
            <li><Link to="/financing">Financing</Link></li><li><Link to="/faq">FAQ</Link></li><li><Link to="/guides">Project guides</Link></li><li><Link to="/blog">Blog</Link></li>
          </ul>
        </div>
        <div className="footer-contact">
          <h2>Visit or call</h2>
          <address>{business.STREET}<br />{business.CITY}, {business.REGION} {business.POSTAL_CODE}</address>
          <a href={`tel:${business.PHONE_E164}`}>{business.PHONE}</a>
          <a href={`mailto:${business.EMAIL}`}>{business.EMAIL}</a>
          <p>Mon–Fri, 9:00–4:30<br />Weekends by appointment</p>
        </div>
      </div>
      <div className="footer-bottom page-width">
        <span>© {new Date().getFullYear()} {business.LEGAL_NAME}</span>
        <span><Link to="/privacy-policy">Privacy</Link><Link to="/terms-of-service">Terms</Link></span>
      </div>
    </footer>
  );
}
